import { NOTIFICATION_TYPES, STEP_STATUS } from "../notifications.consts";

export const STEP_STATUS_DISPLAY_TEXT = {
  [STEP_STATUS.NOT_STARTED]: "",
  [STEP_STATUS.SKIPPED]: "Not required",
  [STEP_STATUS.IN_PROGRESS]: "In progress...",
  [STEP_STATUS.COMPLETED]: "Completed",
  [STEP_STATUS.FAILED]: "Failed to complete"
};

export const STEP_CONTENT = {
  [NOTIFICATION_TYPES.PREVIEW]: {
    title: "Prepare preview steps",
    steps: [
      "Reviewing latest version",
      "Building agent knowledge",
      "Preparing preview"
    ],
    successMessage: "Preparing preview completed successfully"
  },
  [NOTIFICATION_TYPES.BUILD]: {
    title: "Build steps",
    steps: [
      "Reviewing latest version",
      "Building agent knowledge",
      "Creating version"
    ],
    successMessage: "Build process  completed successfully at"
  },
  [NOTIFICATION_TYPES.PUBLISH]: {
    title: "Publishing changes steps",
    steps: [
      "Reviewing latest version",
      "Building agent knowledge",
      "Deploying version"
    ],
    successMessage: "Publishing completed successfully at"
  }
};
